import styled from "styled-components";

export const ChatFooterSendButton = styled.button`
  && {
    ${(props) => props?.theme?.themeConfig?.chatFooter?.inputGroup?.sendButton?.styles}

    svg {
      path {
        fill: ${(props) => props.disabled ? 'grey' : props.theme.themeConfig.primaryColor};
      }
    }
  }
`
